class OpeningHours extends HTMLElement {
  todayTranslation = this.getAttribute('today') || 'Today:';

  connectedCallback() {
    const date = new Date();
    const day = date.getDay();
    const todaySelector = this.querySelectorAll(`[data-opening-hours="day-${day}"]`);

    todaySelector.forEach((element, index) => {
      element.classList.add('font-bold','-order-1');
      if (index === 0) element.textContent = this.todayTranslation;
    });
  }
}

customElements.define('opening-hours', OpeningHours);
